

import Vue from "vue"
import Component from "vue-class-component"
import {MemberCube, MemberSnapshotCube} from "@/cube"

export interface Filter {
  name: string
  title: string
  options: Array<any>
  width: number
  value?: string
}

function withPrefixOption(options: Array<string>) {
  return options.map((option, index) => ({
    label: option,
    value: `${index + 1}|${option}`,
  }))
}

@Component
export default class FilterDimensionSelect extends Vue {
  selectedFilters = new Array<Filter>()

  isDirty = false

  // TODO Source this from Cube?
  options: Array<Filter> = [
    {
      name: MemberCube.gender,
      title: "Gender",
      options: withPrefixOption(["Male", "Female"]),
      width: 80,
    },
    {
      name: MemberSnapshotCube.ageGroup,
      title: "Age group",
      options: withPrefixOption([
        "30 and below",
        "31 - 44",
        "45 - 54",
        "55 - 64",
      ]),
      width: 100,
    },
    {
      name: MemberSnapshotCube.salaryGroup,
      title: "Salary Group",
      options: withPrefixOption([
        "< $30k",
        "$30k ",
        "$65k ",
        "$100k ",
        "$150k ",
        "> $250k",
        "Unknown",
      ]),
      width: 115,
    },
    {
      name: MemberCube.addressState,
      title: "Address state",
      options: ["NSW", "QLD", "SA", "TAS", "VIC", "WA"].map(option => ({
        label: option,
        value: option,
      })),
      width: 125,
    },
  ]

  get isShowLabel() {
    return this.selectedFilters.length === 0
  }

  get selectedFiltersReversed() {
    return this.selectedFilters.slice().reverse()
  }

  onPopupHide() {
    this.$emit("filter-selected", this.selectedFilters)
  }

  clearValue(details: any) {
    details.value = null

    this.$emit("filter-removed", this.selectedFilters)
  }
}
